import { render, staticRenderFns } from "./image-share.vue?vue&type=template&id=66bae554"
import script from "./image-share.vue?vue&type=script&lang=js"
export * from "./image-share.vue?vue&type=script&lang=js"
import style0 from "./image-share.vue?vue&type=style&index=0&id=66bae554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports